import React from 'react';
import { Button } from 'antd';
import { useTenantNavigation } from '../hooks/useTenantNavigation.js';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useTenantNavigation();

  const goHome = () => {
    // Navigate to appropriate home based on user role
    const userInfo = JSON.parse(localStorage.getItem('v_userInfo') || '{}');
    if (userInfo.isAdmin) {
      navigate('/app/dashboard');
    } else {
      navigate('/app/dashboard');
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: 'linear-gradient(135deg, #E8EAF6 0%, #F3E5F5 100%)',
        backgroundImage: 'url(/Grid.svg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="max-w-lg w-full text-center">
        {/* 404 Illustration */}
        <div >
          <img
            src="/404.svg"
            alt="404 Not Found"
            className="mx-auto"
            style={{ maxWidth: '500px', width: '100%' }}
          />
        </div>



        {/* Button */}
        <Button
          // type="primary"
          onClick={goHome}
          style={{
            backgroundColor: '#141BCB',
            borderColor: '#141BCB',
            height: '44px',
            fontSize: '16px',
            fontWeight: '500',
            borderRadius: '8px',
            padding: '0 32px'
          }}
          className="text-white"
          size="large"
        >
          {t('Go to Dashboard')}
        </Button>
      </div>
    </div>
  );
};

export default NotFound;